export interface EditNoteDialogData {
  title: string | null;
  note: string;
}

export interface EditNoteDialogResult {
  readyForSubmission: boolean;
  title: string | null;
  note: string;
}
